import React from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
import { haptics } from '../../lib/utils/haptics';
export function RelatedProducts() {
  const {
    scrollContainerRef,
    currentSlide,
    isMobile,
    handleScroll,
    scrollToSlide
  } = useHorizontalScroll();
  const products = [{
    id: 7,
    name: 'Creatine Monohydrate Powder',
    brand: 'Optimum Nutrition',
    price: 18.99,
    originalPrice: 26.99,
    discount: 30,
    rating: 4.9,
    reviewCount: 412,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 8,
    name: 'BCAA Amino Acids',
    brand: 'Scivation',
    price: 21.99,
    originalPrice: 32.99,
    discount: 33,
    rating: 4.7,
    reviewCount: 289,
    image: PRODUCT_IMAGES[1],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 9,
    name: 'Mass Gainer Protein',
    brand: 'Serious Mass',
    price: 34.99,
    originalPrice: 49.99,
    discount: 30,
    rating: 4.6,
    reviewCount: 234,
    image: PRODUCT_IMAGES[2],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }, {
    id: 10,
    name: 'L-Glutamine Powder',
    brand: 'NOW Sports',
    price: 14.99,
    originalPrice: 22.99,
    discount: 35,
    rating: 4.5,
    reviewCount: 167,
    image: PRODUCT_IMAGES[3],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 11,
    name: 'Beta-Alanine Powder',
    brand: 'BulkSupplements',
    price: 17.99,
    originalPrice: 25.99,
    discount: 31,
    rating: 4.4,
    reviewCount: 198,
    image: PRODUCT_IMAGES[4],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 12,
    name: 'Casein Protein Powder',
    brand: 'Optimum Nutrition',
    price: 26.99,
    originalPrice: 37.99,
    discount: 29,
    rating: 4.8,
    reviewCount: 312,
    image: PRODUCT_IMAGES[0],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }];
  const totalSlides = Math.ceil(products.length / 2);
  return <div className="bg-white rounded-lg border border-gray-200 p-4 md:p-6" data-id="element-5196" data-mp="ilr6hza25v6z">
      <div className="flex items-center justify-between mb-4 md:mb-6" data-id="element-5197" data-mp="intwijb7nobp">
        <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-5198" data-mp="mm1a55ado9io">
          Related Products
        </h3>
        <a href="#" className="text-sm font-medium text-[#723881] bg-purple-100 px-3 py-1 rounded-full hover:bg-purple-200 transition-colors" data-id="element-5199" data-mp="rmyrxgrh71jn">
          View All
        </a>
      </div>
      {/* Mobile Slider */}
      {isMobile ? <div className="relative" data-id="element-5200" data-mp="2yc3n6vefwnhs">
          <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-5201" data-mp="2ydf0bltrz7lk">
            {products.map(product => <div key={product.id} className="snap-start flex-shrink-0" style={{
          width: 'calc(50% - 6px)'
        }} data-id="element-5202" data-mp="2c4q3omky5llk">
                <EnhancedProductCard product={product} data-id="element-5203" data-mp="34sm0draindic" />
              </div>)}
          </div>
          {/* Pagination Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-5204" data-mp="2zshhxvq1s8ph">
            {Array.from({
          length: totalSlides
        }).map((_, index) => <button key={index} onClick={() => scrollToSlide(index)} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-5205" data-mp="1off06xc7pd3q" data-mpi={index} />)}
          </div>
        </div> :
    // Desktop Grid
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-5206" data-mp="2ybu0s9vw3iai">
          {products.map(product => <EnhancedProductCard key={product.id} product={product} data-id="element-5207" data-mp="33aditz7d49xl" />)}
        </div>}
    </div>;
}